<template>
  <div v-if="this.football.is_kyay_open" class="fb-page fb-maung">
    <div class="bet-footer">
      <div class="bet-bar">
        <span class="bet-label"
          >{{ $i18n.locale === "mm" ? "မောင်း" : $t("football.matches") }}
          <span class="badge badge-pill">{{
            this.getFBOrder.fb_matches.length
          }}</span>
        </span>
        <div class="bet-amount">
          <input
            type="number"
            ref="amount"
            v-model="amount"
            class="form-control amount"
            placeholder="500 Unit"
          />
          <small class="text-danger">{{ errors.amount }}</small>
        </div>
        <button
          class="bet-btn"
          type="button"
          @click="
            $playSound();
            setToPreviewVoucher();
          "
        >
          {{ $t("lottery.bet") }}
        </button>
      </div>
    </div>

    <h3 class="page-title">{{ $t("football.mix_parlay") }}</h3>

    <!-- <h1
            class="text-center my-2 mx-2 py-1"
            style="
                background: linear-gradient(#222222, #222222);
                color: white;
                border-radius: 5px;
                font-size: 15px
            "
        >
            {{$t('football.today')}}
                <span style="color: #ff5800">&nbsp;{{ drawDate }}&nbsp;</span>
            {{$t('football.matches')}}
            <i
                class="fas fa-long-arrow-alt-up"
                style="color: red"
                v-if="isToday"
                @click="changeToday"
            ></i>
            <i
                class="fas fa-long-arrow-alt-down"
                style="color: red"
                v-if="!isToday"
                @click="changeToday"
            ></i>
        </h1> -->

    <div class="filter-bar" v-if="matches.length > 0">
      <button
        type="button"
        class="filter-chip reset"
        v-if="filteredMatches.length > 0"
        @click="
          $playSound();
          resetFilter();
        "
      >
        <i class="fas fa-redo"></i>
        {{ $t("football.reset") }}
      </button>
      <button type="button" class="filter-chip" @click="filterModalBox()">
        <i class="fas fa-filter"></i>
        {{ $t("football.filter_by_league") }}
      </button>
    </div>

    <div
      class="loading-wrap"
      v-if="matches.length === 0 && isLoading"
    >
      <Loading color="#e7b534" size="24" class="px-4 py-0 m-auto pb-2" />
      <span>
        {{ $t("please_wait") }}
        <br />
        {{ $t("football.loading") }}
      </span>
    </div>
    <!-- <div
            v-for="(league, leagueIndex) in leagues"
            :key="leagueIndex"
            v-show="isToday && isLeagueHasMatches(league.fbmatches)"
            class="card"
        > -->
    <!-- <div>
                <h3 class="ml-2 pl-2 mt-2">{{ league.name }}</h3>
            </div> -->
    <div class="p-1 mb-5 pb-2" v-if="isToday && !isLoading">
      <FootballTeamCard
        type="maung"
        v-for="(match, index) in filteredMatches.length > 0
          ? filteredMatches
          : matches"
        :key="index"
        :match="match"
        :on-my-event="myEventSource"
      />
    </div>
    <!-- </div> -->
    <div class="col-lg-4 col-md-6 px-2">
      <div class="row">
        <!-- === only amount === -->
        <div class="col-md-4 cart-voucher">
          <div
            class="modal fade"
            id="mobile-voucher"
            tabindex="-1"
            role="dialog"
            aria-labelledby="modal-form"
            aria-hidden="true"
          >
            <div
              class="modal-dialog modal- modal-dialog-centered modal-sm"
              role="document"
            >
              <div class="modal-content">
                <div class="text-center modal-cross" @click="closeModal">X</div>
                <div class="modal-body p-0">
                  <FBPreviewVoucher @remove="removeHistory" type="maung" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- === only amount === -->
    <div class="col-md-4">
      <div
        class="modal fade"
        id="amount"
        tabindex="-1"
        role="dialog"
        aria-labelledby="modal-form"
        aria-hidden="true"
      >
        <div
          class="modal-dialog modal- modal-dialog-centered modal-sm"
          role="document"
        >
          <div class="modal-content">
            <div class="modal-body">
              <div class="card border-0 mb-0">
                <div class="card-body px-lg-5 py-lg-5">
                  <div class="form-group mb-3">
                    {{
                      $store.state.language === "en"
                        ? "Enter Amount"
                        : "ငွေပမာဏထည့်ပါ"
                    }}
                    <div
                      class="mt-2 input-group input-group-merge input-group-alternative"
                    >
                      <div class="input-group-prepend">
                        <span class="input-group-text"
                          ><i class="ni ni-money-coins"></i
                        ></span>
                      </div>
                      <input
                        class="form-control"
                        type="number"
                        v-model="amount"
                      />
                    </div>
                    <span class="text-danger">{{ errors.amount }}</span>
                  </div>
                  <div class="text-center">
                    <button
                      type="button"
                      class="btn btn-primary"
                      @click="setToPreviewVoucher()"
                    >
                      {{
                        $store.state.language === "en"
                          ? "Continue"
                          : "ဆက်သွားမည်"
                      }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="bet-container">
                <button class="btn" style="background: linear-gradient(#e89b9e, #e89b9e) !important; color: black; font-weight: 600;" @click="showModalBox">
                    {{
                        $store.state.language === "en"
                            ? "Bet"
                            : "လောင်းမည်"
                    }}
                </button>
            </div> -->
    </div>

    <!-- === leagues filter === -->
    <div class="col-md-4">
      <div
        class="modal fade"
        id="league-box"
        tabindex="-1"
        role="dialog"
        aria-labelledby="modal-form"
        aria-hidden="true"
      >
        <div
          class="modal-dialog modal- modal-dialog-centered modal-lg"
          role="document"
        >
          <div class="modal-content">
            <div class="modal-body">
              <div class="border-0 py-3 px-3">
                <span class="text-dark mb-2 text-lg" style="font-weight: 500">
                  {{
                    $store.state.language === "en"
                      ? "Please select leagues to filter!"
                      : "ပွဲစဉ်များ စစ်ထုတ်ရန် လိဒ် တစ်ခုခုရွေးချယ်ပေးပါ။"
                  }}
                </span>
                <div class="mb-4 mt-2" style="height: 50vh; overflow-y: scroll">
                  <van-checkbox-group v-model="checkedLeagues" shape="square">
                    <van-checkbox
                      :name="league"
                      class="my-2"
                      v-for="(league, index) in currentLeagues"
                      :key="index"
                      >{{ league }}</van-checkbox
                    >
                  </van-checkbox-group>
                </div>
                <button
                  type="button"
                  class="done-btn mt-4"
                  @click="closeFilterModal()"
                >
                  DONE
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- <div class="text-center align-items-center mt-5 pt-5" v-else>
            <span class="text-danger font-weight-bold">
                {{$t('football.not_open')}}
        </span>
    </div> -->
</template>
<script>
import { Loading, Dialog } from "vant";
import { mapMutations, mapGetters, mapActions, mapState } from "vuex";
import { newEventSource } from "vue-parent-emit";
import FootballTeamCard from "./components/FootballTeamCard.vue";
import FBPreviewVoucher from "./components/FBPreviewVoucher.vue";

export default {
  components: { FootballTeamCard, FBPreviewVoucher, Loading },
  data() {
    return {
      myEventSource: newEventSource(),
      isGoalPor: false,
      matches: [],
      leagues: [],
      historyLeagues: [],
      isMobile: false,
      amount: null,
      football: {},
      errors: {},
      isHistory: false,
      isToday: true,
      isLoading: false,
      checkedLeagues: [],
      currentLeagues: [],
      filteredMatches: [],
    };
  },
  computed: {
    ...mapGetters(["getFBOrder"]),
    ...mapState(["language"]),
    drawDate() {
      return this.matches[0]?.draw_date;
    },
  },
  watch: {
    language() {
      this.matches = [];
      this.fetchLeagues();
    },
    checkedLeagues() {
      // this.$playSound();
      this.filteredMatches = this.matches.filter((match) => {
        const isExist = this.checkedLeagues.filter(
          (league) => league === match.league
        );
        if (isExist.length > 0) return true;
        else false;
      });
    },
  },
  methods: {
    ...mapActions(["fetchUser"]),
    closeFilterModal() {
      $("#league-box").modal("hide");
    },
    resetFilter() {
      this.checkedLeagues = [];
    },
    filterModalBox() {
      $("#league-box").modal("show");
    },
    isLeagueHasMatches(matches) {
      let matchesTotal = 0;

      for (let i = 0; i < matches.length; i += 1) {
        let isShow = true;
        // if (nowTime.getHours() >= 12) {
        //   if (matches[i].close_time.A === 'PM') {
        //     matchTime.setHours(
        //       parseInt(matches[i].close_time.hh, 10) + 12,
        //       parseInt(matches[i].close_time.mm, 10) - 5,
        //       0,
        //     );
        //     isShow = matchTime > nowTime;
        //   }
        // } else {
        //   if (matches[i].close_time.A === 'AM') {
        //     matchTime.setHours(
        //       parseInt(
        //         matches[i].close_time.hh === '12'
        //           ? 0
        //           : matches[i].close_time.hh,
        //         10,
        //       ),
        //       parseInt(matches[i].close_time.mm, 10) - 5,
        //       0,
        //     );
        //   } else {
        //     isShow = false;
        //   }
        //   isShow = matchTime > nowTime;
        // }
        const matchTime = new Date(this.match.start_time);
        const nowTime = new Date();
        isShow = matchTime > nowTime;
        if (isShow) matchesTotal += 1;
      }
      if (matchesTotal > 0) return true;
      return false;
    },
    sendEvent() {
      this.myEventSource.emit();
    },
    changeHistory() {
      this.isHistory = !this.isHistory;
    },
    changeToday() {
      this.isToday = !this.isToday;
    },
    ...mapMutations(["updateFBOrder", "setWholeFBMatches", "setBetAmount"]),
    closeModal() {
      $("#mobile-voucher").modal("hide");
    },
    showModalBox() {
      $("#amount").modal("show");
    },
    removeHistory() {
      this.setWholeFBMatches([]);
      this.setBetAmount(null);
      this.sendEvent();
    },
    setToPreviewVoucher() {
      this.errors = {};
      if (!this.amount) {
        this.errors.amount =
          this.$store.state.language === "en"
            ? "Please enter amount"
            : "ငွေပမာဏ ထည့်ပေးပါ။";
        return false;
      }
      if (this.amount < this.football.min_maung_fees) {
        this.errors.amount =
          this.$store.state.language === "en"
            ? `Please enter amount more than ${this.football.min_maung_fees}`
            : `${this.football.min_maung_fees} ထက်ပိုထည့်ပေးပါ။`;
        return false;
      }
      if (this.amount > this.football.max_maung_fees) {
        this.errors.amount =
          this.$store.state.language === "en"
            ? `Please enter amount less than ${this.football.max_maung_fees}`
            : `${this.football.max_maung_fees} အောက်ထည့်ပေးပါ။`;
        return false;
      }
      const matches = this.getFBOrder.fb_matches;
      this.setBetAmount(this.amount);
      for (let i = 0; i < matches.length; i += 1) {
        matches[i].bet_amount = this.amount;
      }
      this.setWholeFBMatches(matches);
      $("#amount").modal("hide");
      this.openModalVoucher();
      return true;
    },
    openModalVoucher() {
      if (this.$store.state.fb_order.fb_matches.length === 0) {
        const dataError =
          this.$store.state.language === "en"
            ? "Please select some teams!"
            : "အသင်းတစ်ချို့ ရွေးပေးပါ။";
        this.dialog(dataError);
      } else {
        const matches = this.getFBOrder.fb_matches;
        let isBetAmount = true;
        for (
          let index = 0;
          index < this.getFBOrder.fb_matches.length;
          index += 1
        ) {
          const fbMatch = this.getFBOrder.fb_matches[index];
          if (!fbMatch.bet_amount) {
            isBetAmount = false;
          }
        }
        if (!isBetAmount) {
          $("#amount").modal("show");
        } else {
          $("#mobile-voucher").modal("show");
        }
      }
    },
    dialog(text) {
      Dialog.alert({
        message: text,
        confirmButtonText:
          this.$store.state.language === "en"
            ? "Go Back"
            : "နောက်သို့ပြန်သွားမည်။",
      }).then(() => {
        // on close
      });
    },
    async fetchMatches() {
      try {
        const res = await axios.get("fb-matches", {
          params: {
            isFromClient: true,
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
        this.matches = res.data.data;
      } catch (error) {
        console.log(error);
      }
    },
    async fetchLeagues() {
      try {
        this.isLoading = true;
        const date = new Date();
        // const res = await axios.get('/leagues-fb-matches');
        await this.fetchMatches();
        this.isLoading = false;
        const historyRes = await axios.get("/leagues-fb-matches-history");
        this.historyLeagues = historyRes.data.data;
        for (let index = 0; index < this.matches.length; index += 1) {
          // league filtering
          const match = this.matches[index];
          const isLeague = this.currentLeagues.filter(
            (league) => league === match.league
          );
          if (isLeague.length === 0) {
            this.currentLeagues.push(match.league);
          }

          if (
            this.matches[index].kyayed_team === this.matches[index].first_team
          ) {
            this.matches[index].kyayed_team =
              this.$store.state.language === "mm"
                ? this.matches[index].first_team
                : this.matches[index].first_team_en;
          } else if (
            this.matches[index].kyayed_team === this.matches[index].second_team
          ) {
            this.matches[index].kyayed_team =
              this.$store.state.language === "mm"
                ? this.matches[index].second_team
                : this.matches[index].second_team_en;
          }

          this.matches[index].first_team =
            this.$store.state.language === "mm"
              ? this.matches[index].first_team
              : this.matches[index].first_team_en;

          this.matches[index].second_team =
            this.$store.state.language === "mm"
              ? this.matches[index].second_team
              : this.matches[index].second_team_en;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async fetchFootball() {
      try {
        const res = await axios.get("/football");
        this.football = res.data.data[0];
        this.checkIsKyayOpen();
      } catch (error) {
        console.log(error);
      }
    },
    ready() {
      // const channel = this.$pusher.subscribe('football-channel');
      // channel.bind('football-matches', async (data) => {
      //   if (data.callApi) this.fetchLeagues();
      // });
    },
    checkIsKyayOpen() {
      if (this.football && !this.football.is_kyay_open) {
        const text =
          this.$store.state.language === "en"
            ? "Football Kyay not open yet."
            : "ဘောလုံးကြေးမဖွင့်သေးပါ။";
        Dialog.alert({
          message: text,
          confirmButtonText:
            this.$store.state.language === "en"
              ? "Go Back"
              : "နောက်သို့ပြန်သွားမည်။",
        }).then(() => {
          // on close
          this.$router.push("/home");
        });
      }
    },
  },
  destroyed() {
    this.setBetAmount(null);
    this.setWholeFBMatches([]);
    // this.$pusher.unsubscribe('football-channel');
  },
  unmount() {
    // this.$pusher.unsubscribe('football-channel');
    this.updateFBOrder({ type, value: null });
  },
  async created() {
    const authUser = await this.fetchUser();
    if (!authUser) {
      this.$router.push("/auth/login");
    }
    this.updateFBOrder({ type: "type", value: "maung" });
    // this.fetchMatches();
    this.fetchLeagues();
    this.fetchFootball();
    // this.checkIsKyayOpen();

    this.ready();
    if (window.innerWidth < 768) {
      this.isMobile = true;
    }
  },
};
</script>
<style scoped>
.bet-container {
  position: fixed;
  bottom: 0;
  margin-bottom: 5vh;
  width: 100px;
  right: 0;
  left: 0;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0.25em;
  color: white;
  z-index: 100;
  visibility: visible;
  opacity: 1;
}
.modal-cross {
  width: 25px;
  height: 25px;
  border-radius: 50%;
  padding-top: 3px;
  margin-left: auto;
  color: white;
  cursor: pointer;
  margin-right: -9px;
  margin-top: -9px;
  background: rgb(228, 87, 87);
}
.bet-footer {
  position: fixed;
  bottom: 0;
  width: 100%;
  height: auto;
  /* border-top: 2px solid black; */
}
</style>
